import { UserInterface, UserRolesEnum } from './user.interface';
import { ErrorInterface } from './general.interface';

export interface RegisterInterface {
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  password: string;
  inviteToken: string;
}

export interface LoginInterface {
  email: string;
  password: string;
}

export interface AuthUserEntityInterface {
  role?: UserRolesEnum | null;
  id: string;
  ttl: number;
  type: string;
  refreshToken: string;
  createdAt: number;
  userID: number;
  user: UserInterface;
}

export interface LoginCodeInterface {
  email?: string;
  code?: string;
}

export interface ChangePasswordInterface {
  oldPassword?: string;
  newPassword?: string;
}

export interface SetPasswordInterface {
  password?: string;
}

export interface ForgotPasswordInterface {
  email?: string;
}

export interface ResponseLoginInterface {
  errorCode: ErrorInterface;
  response?: AuthUserEntityInterface;
  details?: string;
}
